<form
   class="col-xd-12 col-sm-9 col-md-6 col-lg-3 center"
   (ngSubmit)="submitForm()"
   [formGroup]="resetPasswordForm"
>
   <div>
      <img [src]="mtsLogo" alt="MedTracS" style="max-width: 100%" />
   </div>
   <br />
   <div
      class="alert alert-info"
      style="margin-top: 1rem; margin-bottom: 0"
   >
      {{
         'Guideline: at least 12 characters, 1 special character (of "!@#$%^&"), 1 number, 1 uppercase and 1 lowercase letter of the English alphabet.'
            | translate
      }}
   </div>
   <br />
   <input
      id="pw1"
      class="form-control"
      type="password"
      formControlName="pw1"
      placeholder="{{ 'New password' | translate }}"
      pattern="^(?=.*[\w])(?=.*[\W])[\w\W]{12,}$"
   />
   <input
      id="pw2"
      class="form-control"
      type="password"
      formControlName="pw2"
      placeholder="{{ 'Confirm password' | translate }}"
      pattern="^(?=.*[\w])(?=.*[\W])[\w\W]{12,}$"
   />

   <button
      class="btn btn-block"
      [ngClass]="btn"
      type="submit"
      [disabled]="!resetPasswordForm.valid"
      >{{ 'Reset password' | translate }}</button
   >
   <div>
      <a routerLink="/login">{{ 'Back to login' | translate }}</a>
   </div>
   <br/>
   <div *ngIf="passwordChanged && !resetPasswordForm.touched" class="alert alert-success">
      {{ 'Password changed successfully!' | translate }}
   </div>
</form>
<lib-modal [handler]="tokenExpiredHandler"></lib-modal>